const TimingValues = Object.freeze({
    '--timings-fast': '100ms',
    '--timings-default': '300ms',
    '--timings-medium': '500ms',
    '--timings-long': '1000ms',
    '--timings-heavy': '2000ms',
});
const Timings = {
    fast: 'var(--timings-fast)',
    default: 'var(--timings-default)',
    medium: 'var(--timings-medium)',
    long: 'var(--timings-long)',
    heavy: 'var(--timings-heavy)',
};

export { TimingValues, Timings };
